(function($) {

    const INTERVAL_SEC = 3;

    $.fn.commentForm = function(options) {
        options = $.extend({
            itemsContainerSelector: null,
            replyButtonSelector: null,
            mentionButtonSelector: null,
            inlineReplyContainer: null,
            controlAnonymous: null,
            commentRefreshButtonSelector: null,
            ignoreTargetSaveUrl: null,
            ignoreTargetData: null,
            style: 'default',
            displayGuestTrackInfoNow: true,
            selfAccountInfo: null,
        }, options);
        const $form = $(this);

        if ($form.data('comment-form-initialized') === true) {
            // error 2回初期化するのはナシで!
            return;
        }
        $form.data('comment-form-initialized', true);

        const $initialFormContainer = $form.parent();
        const itemsContainerSelector = options.itemsContainerSelector;
        const $itemsContainer = $(options.itemsContainerSelector);
        const replyButtonSelector = options.replyButtonSelector;
        const mentionButtonSelector = options.mentionButtonSelector;
        const inlineReplyContainer = options.inlineReplyContainer;
        const controlAnonymous = options.controlAnonymous;
        const commentRefreshButtonSelector = options.commentRefreshButtonSelector;

        const $contentTextInput = $form.find('[name="content"]');
        const $submitButton = $form.find('.submit');
        // 送信中インジケータ用に元ラベルを保持 (updateSubmitButtonStatus で差し替え/復帰)。
        // 「送信」→「送信中…」での幅の伸び縮みは、ボタン側の min-width 確保で防ぐ
        // (_form-comment.php / _form-comment-modification.php の submit ボタン style)。
        $submitButton.data('original-html', $submitButton.html());
        const $submitOptionBlock = $form.find('.submit-options');

        // 匿名チェックボックス
        if (controlAnonymous) {
            const $nickname = $form.find('[name="nickname"]');
            $form.find('[name="anonymous"]').on('change', function() {
                const checked = $(this).prop("checked");
                const userThumbnail = $form.find('.form-user-thumbnail');
                const anonymousThumbnail = $form.find('.form-anonymous-thumbnail');
                if (checked) {
                    userThumbnail.hide();
                    anonymousThumbnail.show();
                    if (typeof $nickname.data('modified') === 'undefined') {
                        $nickname.data('modified', "");
                    }
                    $nickname.prop("disabled", false).val($nickname.data('modified'));
                } else {
                    anonymousThumbnail.hide();
                    userThumbnail.show();
                    $nickname.data("modified", $nickname.val());
                    $nickname.prop("disabled", true).val($nickname.data("username"));
                }
            });
            if ($nickname.data('username')) {
                $nickname.prop("disabled", true).val($nickname.data("username"));
            }
        }

        // キー入力
        $contentTextInput.on("change keyup", updateSubmitButtonStatus).trigger('change');

        // リフレッシュ
        let latestCommentNumber = 0;
        let $refreshButton = null;
        if (commentRefreshButtonSelector) {
            $refreshButton = $(commentRefreshButtonSelector);
            $refreshButton.on('click', function() {
                $refreshButton.find('.glyphicon,.fa').addClass('fa-spin');
                $refreshButton.addClass('disabled');
                latestCommentNumber = detectMaxCommentNumber();

                $itemsContainer.one("pjax:end", function() {
                    $refreshButton.removeClass('disabled');
                    $refreshButton.find('.glyphicon,.fa').removeClass('fa-spin');
                    commentItemsWhichNumberIsGreaterThan(
                        latestCommentNumber
                    ).addClass('last-posted-comment-effect');
                });

                $.pjax.reload(itemsContainerSelector, { timeout:5000 });
            });
        }

        //noinspection JSUnusedLocalSymbols
        function wrapByCommentFormAttachEffect($form, fn) {
            //$form.removeClass('comment-form-attached-effect');
            fn();
            //$form.wrap('<div></div>');
            //$form.parent().css({
            //    position: 'relative',
            //    height: $form.height() + 13 // 謎の13px誤差
            //    //overflow: 'hidden'
            //});
            //$form.css({
            //    position: 'absolute',
            //    top: 0,
            //    left: 0,
            //    width: $form.parent().width()
            //});
            //$form.addClass('comment-form-attached-effect');
            //setTimeout(function() {
            //    $form.css({
            //        position: '',
            //        top: "",
            //        left: "",
            //        width: ""
            //    });
            //    $form.removeClass('comment-form-attached-effect');
            //    $form.unwrap();
            //}, 500);
        }

        // リプライ
        if (replyButtonSelector) {
            $itemsContainer.on('click', replyButtonSelector, function() {
                const $button = $(this);
                const $commentElement = $button.closest('.comment');
                const $box = $commentElement.find(inlineReplyContainer).not(
                    $commentElement.find('.list-view ' + inlineReplyContainer)
                );
                $form.find('[name=reply_to]').val($button.data('to'));
                if ($button.is('button')) $button.hide(); // ラジオボタンは隠さない

                wrapByCommentFormAttachEffect($form, function() {
                    $box.append($form);
                    $itemsContainer.find(replyButtonSelector).not($button).show();
                    $form.find('.reply-target-number .number').text($button.data('to'));
                    $form.find('.reply-target-number').show();
                });
                if ($refreshButton) {
                    $refreshButton.trigger('commentForm:changeState');
                }
            });
        }

        if (mentionButtonSelector) {
            $itemsContainer.on('click', mentionButtonSelector, function() {
                const $button = $(this);
                const $commentElement = $button.closest('.comment');
                const $box = $commentElement.find(inlineReplyContainer).not(
                    $commentElement.find('.list-view ' + inlineReplyContainer)
                );

                const textarea = $form.find('[name=content]');
                let content = textarea.val();
                if (content !== "") {
                    content += "\n\n";
                }
                textarea.val(content + ">> " + $button.data('to'));

                wrapByCommentFormAttachEffect($form, function() {
                    $box.append($form);
                    $itemsContainer.find(replyButtonSelector).not($button).show();
                    $form.find('.reply-target-number .number').text($button.data('to'));
                    $form.find('.reply-target-number').show();
                });
                $refreshButton.trigger('commentForm:changeState');
            });
        }

        $form.find('.cancel').on('click', function() {
            $form.find('[name=reply_to]').val($initialFormContainer.data('reply-to'));
            $itemsContainer.find(replyButtonSelector).show()
                .filter(':radio').prop('checked',false); // ラジオボタンはチェックを外す

            wrapByCommentFormAttachEffect($form, function() {
                $initialFormContainer.append($form);
                $form.find('.reply-target-number .number').text('');
                $form.find('.reply-target-number').hide();
            });
            $refreshButton.trigger('commentForm:changeState');
        });

        // Pjaxコメント送信 おちつくまで数秒待つ
        $form.data('comment-form-submitting', false);
        $form.data('comment-form-waiting', false);
        $form.find('form').on('submit', function (event) {
            if (!canSubmit()) {
                return false;
            }
            if ($form.data('comment-form-submitting') !== true && $form.data('comment-form-waiting') !== true) {
                $form.data('comment-form-submitting', true);
                $form.data('comment-form-waiting', true);
                updateSubmitButtonStatus();
                const options = {
                    push: false,
                    replace: true,
                    timeout: 0,
                    scrollTo: null
                };
                // ツリーで返信先番号があればページング中のURLを維持する
                if ($form.find('[name=reply_to]').val()) {
                    options.url = location.href;
                }

                if (commentRefreshButtonSelector && $(commentRefreshButtonSelector).is('.should-inject-new-arrival')) {
                    // タイムラインモードの自動更新が発動中ならこっち

                    const $targetForm = $(event.currentTarget);
                    const formData = $targetForm.serializeArray();

                    $.ajax({
                        url: $targetForm.attr('action'),
                        type: $targetForm.attr('method'),
                        data: formData,
                        dataType: 'json'
                    }).done(function(data){
                        if (!!data && !!data.status) {
                            if (data.status === 'ok' || data.status === 'warning') {
                                if (data.status === 'warning') {
                                    bootbox.alert(data.warning);
                                }
                                // リロード指示メッセージを発行
                                $(commentRefreshButtonSelector).trigger('commentForm:post');

                                // 初期化
                                if ($form.find('.reply-target-number').is(':visible')) {
                                    $initialFormContainer.append($form);
                                }
                                $contentTextInput.val("").trigger("keyup").trigger("change");
                                $contentTextInput.focus();

                                updateInitialFormContainerVisibility();
                                $form.find('.reply-target-number .number').text('');
                                $form.find('.reply-target-number').hide();
                                $form.find('[name=reply_to]').val($initialFormContainer.data('reply-to'));

                            } else if (data.status === 'error') {
                                bootbox.alert(data.error);
                            }
                        } else {
                            // 200 だが status が無い等の異常応答
                            bootbox.alert("予期しない応答が返りました。ページを再読み込みしてください。");
                        }
                        // done したら必ず送信状態を解除する
                        // (status 異常/null でも「送信中…」スピナーが張り付かないように、if の外で実行)
                        $form.data('comment-form-submitting', false);
                        updateSubmitButtonStatus();
                    }).fail(function(){
                        // 安全のため pjax で再試行
                        event.result = true;
                        $.pjax.submit(event, itemsContainerSelector, options);
                    });
                    event.preventDefault();
                } else {
                    event.result = true;
                    $.pjax.submit(event, itemsContainerSelector, options);
                }
                setTimeout(function() {
                    $form.data('comment-form-waiting', false);
                    updateSubmitButtonStatus();
                }, INTERVAL_SEC * 1000);
            }
            return false;
        });

        if (window.hide_comments) {
            window.hide_comments.start(
                $itemsContainer, options.style, options.displayGuestTrackInfoNow, options.ignoreTargetSaveUrl,
                options.ignoreTargetData, options.selfAccountInfo
            );
        }

        // Pjaxイベントすべて
        $itemsContainer.on("pjax:start", function() {
            //$form.find('input,textarea,button,.btn').addClass('disabled');

            if (window.lazyload_fix) {
                window.lazyload_fix.prepare($itemsContainer); // in lazy-load-fix.js
            }

        }).on("pjax:beforeReplace", function(event, content, options) {
            window.hide_comments.prepare($itemsContainer);
            if ($form.find('.reply-target-number').is(':visible')) {
                $initialFormContainer.append($form);
                // $form.hide().slideDown();   //?? うごかない
            } else {
                if (options.type === 'POST' && $form.data('comment-form-submitting')) {
                    $contentTextInput.focus();
                }
            }
        }).on("pjax:success", function(/*event, xhr, textStatus, errorThrown, options*/) {
            const errorCount = $itemsContainer.find('.comment-errors').data('errors');
            if ($form.data('comment-form-submitting') && (
                isNaN(errorCount) || parseInt(errorCount) === 0
                )) {
                $contentTextInput.val("").trigger("keyup").trigger("change");
            }

            // スライダーUIの描画更新を早めるため以下やや遅れて実行
            setTimeout(function(){
                if (window.lazyload_fix) {
                    window.lazyload_fix.done($itemsContainer); // in lazy-load-fix.js
                }
                if (window.hide_comments) {
                    window.hide_comments.update($itemsContainer);
                }
            }, 10);

        }).on("pjax:error", function(event, xhr, textStatus, errorThrown) {
            if (xhr.status === 0 && errorThrown === 'abort') {
                return false;
            }
            if (xhr.status === 0 && errorThrown === 'timeout') {
                bootbox.alert("サーバーとの通信に時間がかかりすぎたため、処理を中断しました。ページを再読み込みしてください。");
                // POSTはクライアント側タイムアウトがないはず
                return false;
            }
            if (xhr.status === 0 && xhr.statusText === 'error') {
                bootbox.alert("サーバーとの通信が行えませんでした。ページを再読み込みしてください。");
                return false;
            }
            // 「コメントの投稿」を受け付けられなかった既知のステータスは、それぞれの理由を言語化して伝える。
            // ただし 400/403/404 は CSRF トークン切れや、フロントエンドとバックエンドの不整合が原因の場合もあり、
            // 原因を断定できない。いずれも「〜かもしれません」とし、ページ再読み込みでの回復を促す。
            switch (xhr.status) {
                case 400:
                    // CSRF トークン切れなど、リクエストが正しく組み立てられていない可能性がある。
                    bootbox.alert("リクエストが正しく送信できませんでした。ページの情報が古くなっているかもしれません。ページを再読み込みしてからお試しください。");
                    return false;
                case 403:
                    // 投稿権限がない、または権限情報が古くなっている可能性がある。
                    bootbox.alert("コメントを投稿する権限がありませんでした。ページの情報が古くなっているかもしれません。ページを再読み込みしてからお試しください。");
                    return false;
                case 404:
                    // 投稿先が見つからない、または参照情報が古くなっている可能性がある。
                    bootbox.alert("投稿先が見つかりませんでした。すでに削除されたか、ページの情報が古くなっているかもしれません。ページを再読み込みしてからお試しください。");
                    return false;
                case 429:
                    // 短時間の連投。頻度の問題なので時間をおけば投稿できる。
                    bootbox.alert("短時間に連続して投稿されたため、コメントを受け付けられませんでした。少し時間をおいてから投稿してください。");
                    return false;
            }
            bootbox.alert("予期しないネットワークエラーが発生しました。ページを再読み込みしてください。");
            return false;
        }).on("pjax:end", function() {
            updateInitialFormContainerVisibility();
            $form.find('.reply-target-number .number').text('');
            $form.find('.reply-target-number').hide();
            //$form.find('input,textarea,button,.btn').removeClass('disabled');
            $form.find('[name=reply_to]').val($initialFormContainer.data('reply-to'));

            $form.data('comment-form-submitting', false);
            updateSubmitButtonStatus();
            if (commentRefreshButtonSelector) {
                $(commentRefreshButtonSelector).removeClass('disabled');
                $(commentRefreshButtonSelector).find('.glyphicon,.fa').removeClass('fa-spin');
            }
        });

        function updateInitialFormContainerVisibility() {
            const $firstPaginationButton = $itemsContainer.find('.pagination .first');
            if ($firstPaginationButton.length === 0 || $firstPaginationButton.hasClass('disabled')) {
                $initialFormContainer.show();
            } else {
                $initialFormContainer.hide();
            }
        }

        function updateSubmitButtonStatus() {
            if (!canSubmit()) {
                $submitButton.addClass("disabled");
            } else {
                $submitButton.removeClass("disabled");
            }
            // 送信中 (通信中) はスピナー＋「送信中…」を表示し、進行を可視化して連打欲求を抑える。
            // 完了 (pjax:end / ajax 完了) で submitting=false になり元ラベルへ復帰。
            // data('sending') ガードで重複注入 (= fa-spin アニメ再開のちらつき) を防止。
            const sending = $form.data('comment-form-submitting');
            if (sending && !$submitButton.data('sending')) {
                $submitButton.data('sending', true);
                $submitButton.html('<i class="fa-solid fa-spinner fa-spin"></i> 送信中…');
            } else if (!sending && $submitButton.data('sending')) {
                $submitButton.data('sending', false);
                $submitButton.html($submitButton.data('original-html'));
            }
        }

        function canSubmit() {
            const empty = $.trim($contentTextInput.val()).length === 0;
            const submitting = $form.data('comment-form-submitting') || $form.data('comment-form-waiting');
            return !(empty || submitting);
        }

        function appendEnterToSend() {
            const isMac = navigator.userAgent.match(/Mac|PPC/);
            const isIOs = navigator.userAgent.match(/iOS/);
            $(
                '<label for="enter-to-send"><input type="checkbox" id="enter-to-send"/> <small class="text-muted">' + ((isMac || isIOs) ? '&crarr;' : 'Enter') + 'を押して送信</small></label>'
            ).appendTo($submitOptionBlock).tooltip({
                placement: 'top',
                html: true,
                title: '入力中に ' + (isMac ? '&#8984; + &crarr;' : 'Ctrl + Enter') + ' でも送信できます'
            });
            $contentTextInput.on('keydown', function(event) {
                const modKey = isMac ? event.metaKey : event.ctrlKey;
                if (($form.find('#enter-to-send').prop('checked') || modKey) && event.keyCode === 13) {
                    $form.find('form').trigger('submit');
                    return false;
                }
            });
            // 基本はENTER効かない
            $form.find('form input').on('keypress', function(event) {
                if (event.keyCode === 13 && !(event.metaKey || event.ctrlKey)) {
                    event.preventDefault();
                }
            });
        }
        appendEnterToSend();

        function detectMaxCommentNumber() {
            let v = 0;
            $itemsContainer.find('[data-key]').each(function() {
                v = Math.max(v, parseInt($(this).data('key')));
            });
            return v;
        }

        function commentItemsWhichNumberIsGreaterThan(n) {
            return $itemsContainer.find('[data-key]').filter(function() {
                return parseInt($(this).data('key')) > n;
            });
        }

        updateInitialFormContainerVisibility();
        updateSubmitButtonStatus();
    };
})(jQuery);
